import { Routes } from '@angular/router';
import { authGuard } from './core/guards/auth-guard/auth-guard';
import { protectedRouteGaurd, guestEntryGuard } from './core/guards/guest-guard/guest-guard';
import { NotAuthorized } from './core/components/not-authorized/not-authorized/not-authorized';
import { InactiveTenant } from './core/components/inactive-tenant/inactive-tenant';
import { UserResolver } from './core/services/user-resolver-service/user-resolver';
import { GuestLayout } from './features/guest/guest-layout/guest-layout';

export const routes: Routes = [
  {
    path: 'auth',
    canActivate: [protectedRouteGaurd],
    loadChildren: () =>
      import('@/app/features/pre-login/auth/auth.routes').then((m) => m.AuthRoutes),
  },
  {
    path: '',
    pathMatch: 'full',
    canActivate: [guestEntryGuard],
    component: GuestLayout,
  },
  {
    path: '',
    canActivate: [authGuard],
    resolve: { user: UserResolver },
    loadChildren: () =>
      import('./features/post-login/post-login-routes').then((m) => m.postLoginRoutes),
  },

  {
    path: 'unauthorized',
    component: NotAuthorized,
  },
  {
    path: 'inactive-tenant',
    component: InactiveTenant,
  },
  {
    path: '**',
    redirectTo: '/auth/login',
  },
];
